import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';

export const adminMarketingToolNewRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/tools/marketing_tools/new',
}).lazy(() =>
  import('pages/admin/MarketingTools/AdminMarketingToolNewPage/AdminMarketingToolNewPage').then(
    (d) => d.Route
  )
);
